import { ISurveyResultsFilter } from 'models';

export enum IReportKeys {
	surveyId = 'surveyId',
	surveysName = 'surveysName',
	marks = 'marks',
	surveyRoundId = 'surveyRoundId',
}

export interface IReportPayload extends ISurveyResultsFilter {
	[IReportKeys.surveyId]: string;
	[IReportKeys.surveysName]: string;
	[IReportKeys.surveyRoundId]: string;
	[IReportKeys.marks]: Array<number>;
}
